import Authorization from "./components/Authorization.vue"
import Documents from "./components/Documents.vue"
import SignersMonitor from "./components/SignersMonitor.vue"

export default [
  {
    path: "/authorization/:obj/:lang",
    name: "Authorization",
    component: Authorization,
    props: true,
  },
  {
    path: "/authorization",
    name: "Authorization",
    component: Authorization,
    props: true,
  },
  {
    path: "/documents",
    name: "Documents",
    component: Documents,
    props: true,
  },
  {
    path: "/signersMonitor",
    name: "SignersMonitor",
    component: SignersMonitor,
    props: true,
  },
]
